<a class="link" *ngIf="entity"
   (click)="downloadButtonComponent.execute()">{{entity.originalFilename}}</a>
<app-document-download [entity]="entity" #downloadButtonComponent></app-document-download>